import * as React from "react";
import { forwardRef, memo } from "react";
const SvgThumbUp = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M280-120v-520l240-238q15-15 35.5-17.5T595-888t28 28 4 37l-45 183h258q32 0 56 24t24 56v80q0 7-2 15t-4 15L794-168q-9 20-30 34t-44 14zm80-486v406h360l120-280v-80H480l54-220zM160-120q-33 0-56.5-23.5T80-200v-360q0-33 23.5-56.5T160-640h120v80H160v360h120v80zm200-80v-406z" })));
const ForwardRef = forwardRef(SvgThumbUp);
const Memo = memo(ForwardRef);
export default Memo;
